import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentStatusBadge = ({ status, method, size = 'default' }) => {
  const getPaymentConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'paid':
        return {
          label: 'Paid',
          icon: 'CheckCircle',
          className: 'bg-success/10 text-success border-success/20'
        };
      case 'pending':
        return {
          label: 'Pending',
          icon: 'Clock',
          className: 'bg-warning/10 text-warning border-warning/20'
        };
      case 'failed':
        return {
          label: 'Failed',
          icon: 'XCircle',
          className: 'bg-error/10 text-error border-error/20'
        };
      case 'refunded':
        return {
          label: 'Refunded',
          icon: 'RotateCcw',
          className: 'bg-secondary/10 text-secondary border-secondary/20'
        };
      default:
        return {
          label: 'Unknown',
          icon: 'HelpCircle',
          className: 'bg-muted text-muted-foreground border-border'
        };
    }
  };

  const getMethodIcon = (method) => {
    switch (method?.toLowerCase()) {
      case 'mobile money': case'mtn mobile money': case'airtel money':
        return 'Smartphone';
      case 'credit card': case'debit card':
        return 'CreditCard';
      case 'bank transfer':
        return 'Building2';
      case 'cash':
        return 'Banknote';
      default:
        return 'Wallet';
    }
  };

  const config = getPaymentConfig(status);
  const sizeClasses = size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-1.5 text-sm';

  return (
    <div className="flex flex-col space-y-1">
      <span className={`inline-flex items-center space-x-1.5 ${sizeClasses} font-medium rounded-full border ${config?.className}`}>
        <Icon name={config?.icon} size={size === 'sm' ? 12 : 14} />
        <span>{config?.label}</span>
      </span>
      {method && (
        <span className="inline-flex items-center space-x-1 text-xs text-muted-foreground">
          <Icon name={getMethodIcon(method)} size={12} />
          <span>{method}</span>
        </span>
      )}
    </div>
  );
};

export default PaymentStatusBadge;